export interface Config {
  default_admin_email: string
  enums: {
    event: {
      status: { value: EventStatus; label: string }[]
      type: { value: EventType; label: string }[]
      organizer: { value: EventOrganizer; label: string }[]
      attendance_type: { value: AttendanceType; label: string }[]
    }
    session: {
      status: { value: SessionStatus; label: string }[]
      organizer: { value: EventOrganizer; label: string }[]
      type: { value: SessionType; label: string }[]
    }
    sub_event: {
      status: { value: SubEventStatus; label: string }[]
      type: { value: SubEventType; label: string }[]
    }
    option: {
      status: { value: ParticipantOptionStatus; label: string }[]
      type: { value: OptionType; label: string }[]
    }
    participant: {
      status: { value: ParticipantStatus; label: string }[]
      membership_level: { value: MembershipLevel; label: string }[]
      home_region: { value: HomeRegion; label: string }[]
    }
    theme: {
      category: { value: AbstractCategory; label: string }[]
    }
    sponsorship: {
      status: { value: SponsorshipStatus; label: string }[]
      activity: { value: Activity; label: string }[]
    }
    contributor_roles: {
      value: ContributorRole
      label: string
    }[]
  }
}

export enum SessionType {
  BootcampBasic = 'bootcamp_basic',
  BootcampAdvanced = 'bootcamp_advanced',
  BootcampSupervisor = 'bootcamp_supervisor',
  JfefAg = 'jfef_ag',
  JfefCa = 'jfef_ca',
  JfefInaugural = 'jfef_inaugural',
  JfefComLibre = 'jfef_com_libre',
  JfefThematicSession = 'jfef_thematic_session',
  JfefSymposium = 'jfef_symposium',
  JfefResearch = 'jfef_research',
  JfefBreak = 'jfef_break',
  JfefWorkshop = 'jfef_workshop',
  JfefPoster = 'jfef_poster',
  JfefExpo = 'jfef_expo',
  JfefCollege = 'jfef_college',
  JfefMeeting = 'jfef_meeting',
  JfefPartner = 'jfef_partner',
  JfefDpc = 'jfef_dpc',
  JfefLunch = 'jfef_lunch',
}

export enum BlankEnum {
  Any = '',
}

export enum ContributorRole {
  Speaker = 'speaker',
  Moderator = 'moderator',
  Responsible = 'responsible',
  Trainer = 'trainer',
  Supervisor = 'supervisor',
  Jury = 'jury',
  Participant = 'participant',
}

export enum AbstractCategory {
  Cardiac = 'cardiac',
  Congenital = 'congenital',
  Thoracic = 'thoracic',
}

export enum OptionType {
  SubEventOption = 'SubEventOption',
  SessionOption = 'SessionOption',
  CheckBoxOption = 'CheckBoxOption',
  TextOption = 'TextOption',
  NumberOption = 'NumberOption',
}

export enum SubEventType {
  WelcomeSubEvent = 'WelcomeSubEvent',
  BreakSubEvent = 'BreakSubEvent',
  PresentationSubEvent = 'PresentationSubEvent',
  WorkShopSubEvent = 'WorkShopSubEvent',
  HotelSubEvent = 'HotelSubEvent',
  MealSubEvent = 'MealSubEvent',
  MeetingSubEvent = 'MeetingSubEvent',
  ThesisPresentationSubEvent = 'ThesisPresentationSubEvent',
}

export enum EventStatus {
  Draft = 'draft',
  Published = 'published',
  RegistrationOpen = 'registration_open',
  RegistrationClosed = 'registration_closed',
  InProgress = 'in_progress',
  Completed = 'completed',
  Archived = 'archived',
}

export enum EventType {
  Seminar = 'seminar',
  Congress = 'congress',
  Simulation = 'simulation',
  Simlife = 'simlife',
  Osteosynthese = 'osteosynthese',
  Bootcamp = 'bootcamp',
  Tour = 'rats_tour',
}

export enum EventOrganizer {
  SFCTCV = 'sfctcv',
  ARCOTHOVA = 'archothova',
  SFACCEC = 'sfaccec',
  UNICCT = 'unicct',
  COLLEGE = 'college',
}

export enum AttendanceType {
  Explicit = 'explicit',
  Implicit = 'implicit',
}

export enum SessionStatus {
  Draft = 'draft',
  Confirmed = 'confirmed',
}

export enum SubEventStatus {
  Draft = 'draft',
  Confirmed = 'confirmed',
}

export enum ParticipantStatus {
  PendingCheckout = 'pending_checkout',
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
  CheckoutFailed = 'checkout_failed',
  PendingPartner = 'pending_partner',
}

export enum SponsorshipStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  WaitingList = 'waiting_list',
  Rejected = 'rejected',
  LabSelected = 'lab_selected',
}

export enum ParticipantOptionStatus {
  PendingCheckout = 'pending_checkout',
  WaitingConfirmation = 'waiting_confirmation',
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
  CheckoutFailed = 'checkout_failed',
  WaitingList = 'waiting_list',
}

export enum MembershipLevel {
  Associate = 'associate',
  Full = 'full',
  Honorary = 'honorary',
  NotMember = 'not_member',
}

export enum HomeRegion {
  Nord = 'Nord',
  Ouest = 'Ouest',
  Sud = 'Sud',
}

export enum Activity {
  Cardiac = 'cardiac',
  Thoracic = 'thoracic',
}
